import Vue from "vue";
import VueRouter from "vue-router";
import { store } from "../store/store.js";

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    redirect: "/login",
    name: "Home",
  },
  {
    path: "/login",
    name: "Login",
    component: () =>
      import(/* webpackChunkName: "login" */ "../views/Login.vue"),
  },
  {
    path: "/register",
    name: "Registrierung",
    component: () =>
      import(/* webpackChunkName: "register" */ "../views/Register.vue"),
  },
  {
    path: "/pw-reset-request",
    name: "Passwort-Reset anfordern",
    component: () =>
      import(
        /* webpackChunkName: "pw-reset-request" */ "../views/PWResetRequest.vue"
      ),
  },
  {
    path: "/pw-reset",
    name: "Passwort zurücksetzen",
    component: () =>
      import(/* webpackChunkName: "pw-reset" */ "../views/PWReset.vue"),
  },
  {
    path: "/pw-change",
    name: "Passwort ändern",
    component: () =>
      import(/* webpackChunkName: "pw-change" */ "../views/PWChange.vue"),
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/email-change-request",
    name: "eMail ändern anfordern",
    component: () =>
      import(
        /* webpackChunkName: "email-change-request" */ "../views/eMailChangeRequest.vue"
      ),
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/email-change",
    name: "eMail ändern prüfen",
    component: () =>
      import(/* webpackChunkName: "email-change" */ "../views/eMailChange.vue"),
    meta: {
      requiresAuth: false,
    },
  },

  {
    path: "/meineObjekte",
    name: "VertragsObjekte",
    component: () =>
      import(/* webpackChunkName: "objekte" */ "../views/VertragsObjekte.vue"),
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/meineDokumente",
    name: "Dokumente",
    component: () =>
      import(/* webpackChunkName: "dokumente" */ "../views/Dokumente.vue"),
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/meineDaten",
    name: "meineDaten",
    component: () =>
      import(/* webpackChunkName: "meinedaten" */ "../views/meineDaten.vue"),
    props: true,
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/meineTermine",
    name: "Termine",
    component: () =>
      import(/* webpackChunkName: "termine" */ "../views/Termine.vue"),
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/meineBenachrichtigungen",
    name: "Benachrichtigungen",
    component: () =>
      import(
        /* webpackChunkName: "Benachrichtigungen" */ "../views/Benachrichtigungen.vue"
      ),
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/Benutzerkonto",
    name: "Benutzerkonto",
    component: () =>
      import(
        /* webpackChunkName: "benutzerkonto" */ "../views/Benutzerkonto.vue"
      ),
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/Schadensfall",
    name: "Schadensfall",
    component: () =>
      import(
        /* webpackChunkName: "schadensfall" */ "../views/Schadensfall.vue"
      ),
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/Notfall",
    name: "Notfall",
    component: () =>
      import(/* webpackChunkName: "Notfall" */ "../views/Notfall.vue"),
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/Kuendigung",
    name: "Kündigung",
    component: () =>
      import(/* webpackChunkName: "kuendigung" */ "../views/Kuendigung.vue"),
    meta: {
      requiresAuth: true,
    },
  },
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes,
});

router.beforeEach((to, from, next) => {
  if (to.matched.some((record) => record.meta.requiresAuth)) {
    if (store.state.token == "") {
      next({
        path: "/login",
        params: { nextUrl: to.fullPath },
      });
    } else {
      next();
    }
  } else {
    next();
  }
});

router.onError((err) => {
  store.commit("setRouterStatus", { ok: false, text: err.message });
  console.log("<!-- router error: " + err.message + " -->");
});

router.afterEach(() => {
  store.commit("setRouterStatus", { ok: true, text: "" });
  window.scrollTo({ top: 0, behavior: "smooth" });
});

export default router;
